import { ApiRef, createApiRef } from '@backstage/core-plugin-api';
import { ModelData, LeaderboardEntry } from './modelgarden.objects';

export const modelGardenApiRef: ApiRef<ModelGardenApi> =
  createApiRef<ModelGardenApi>({
    id: 'plugin.aiecosystem-modelgarden.api',
  });

/**
 * Interface for the Model Garden API, which defines methods for retrieving AI model information. The API includes methods to get all models and to get a specific model by its ID. The getModelById method throws a ModelNotFoundError if the requested model does not exist.
 */
export interface ModelGardenApi {
  /**
   * Gets all models existing in Nexus.
   * @returns An array of all models
   */
  getAllModels(): Promise<ModelData[]>;

  /**
   * Gets a model from Nexus by its ID.
   * @param id - The ID of the model to retrieve
   * @throws {ModelNotFoundError} When the model with the given ID does not exist
   * @returns The model with the given ID
   */
  getModelById(id: string): Promise<ModelData>;

  /**
   * Gets a model icon file as a Blob object by its icon ID.
   * @param iconId The id of the icon to fetch the blob data for
   * @returns A Promise that resolves to a Blob object containing the icon data, or null if the icon does not exist
   */
  getIconFile(iconId: string): Promise<Blob | null>;

  /**
   * Clears the in-memory icon cache. Call this when leaving the Model Garden
   * to free Blob memory accumulated during the session.
   */
  clearIconCache(): void;

  /**
   * Gets leaderboard data with model performance metrics from Nexus.
   * @returns An array of leaderboard entries with metric scores
   */
  getModelLeaderboardData(): Promise<LeaderboardEntry[]>;
}
